<ion-card>
  <ion-card-header>
    <ion-card-title>Áttekintés</ion-card-title>
    <ion-card-subtitle>
      Mi vár teendőre az iktatóban. A számokra kattintva a megfelelő listára jutsz.
    </ion-card-subtitle>
  </ion-card-header>
  <ion-card-content>
    <ion-note color="danger" *ngIf="hiba" style="display:block">{{ hiba }}</ion-note>

    <div class="ikt-szamok" *ngIf="adat">
      <div class="ikt-szam" [class.figyelem]="adat.iktatatlan > 0" (click)="nyit('/iktatgato/erkeztetes')">
        <div class="ertek">{{ adat.iktatatlan }}</div>
        <div class="cimke">iktatásra vár</div>
      </div>
      <div class="ikt-szam" (click)="nyit('/iktatgato/ugyiratok')">
        <div class="ertek">{{ adat.folyamatban }}</div>
        <div class="cimke">folyamatban lévő ügyirat</div>
      </div>
      <div class="ikt-szam" [class.figyelem]="adat.lejart > 0" (click)="nyit('/iktatgato/ugyiratok')">
        <div class="ertek">{{ adat.lejart }}</div>
        <div class="cimke">lejárt határidő</div>
      </div>
      <div class="ikt-szam" (click)="nyit('/iktatgato/irattar')">
        <div class="ertek">{{ adat.irattarazhato }}</div>
        <div class="cimke">irattárazható</div>
      </div>
      <div class="ikt-szam" (click)="nyit('/iktatgato/irattar')">
        <div class="ertek">{{ adat.selejtezheto }}</div>
        <div class="cimke">selejtezhető</div>
      </div>
      <div class="ikt-szam" (click)="nyit('/iktatgato/postakonyv')">
        <div class="ertek">{{ adat.postazasra_var }}</div>
        <div class="cimke">postázásra vár</div>
      </div>
    </div>

    <ion-note color="medium" *ngIf="adat && !adat.hozzaferes?.mindent_lat">
      A számok csak a hozzád rendelt ügyiratokat tartalmazzák.
    </ion-note>

    <div class="ikt-gombsor">
      <ion-button size="small" (click)="nyit('/iktatgato/iktatas')">
        <ion-icon slot="start" name="create-outline"></ion-icon>Új iktatás
      </ion-button>
      <ion-button size="small" fill="outline" (click)="nyit('/iktatgato/erkeztetes')">
        <ion-icon slot="start" name="mail-open-outline"></ion-icon>Érkeztetés
      </ion-button>
    </div>
  </ion-card-content>
</ion-card>
